import React from "react";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
interface BrandingStepProps {
  colorHex: string;
  logoUrl: string | null;
  onColourChange: (value: string) => void;
  onLogoSelect: (file?: File) => void;
  onLogoRemove: () => void;
}

export function ServiceBrandingStep({
  colorHex,
  logoUrl,
  onColourChange,
  onLogoSelect,
  onLogoRemove,
}: BrandingStepProps) {
  return (
    <div className="card">
      <div className="card-title">Choose your branding</div>
      <div className="field-hint">
        Set a logo and a colour to help people recognise this service.
      </div>
      <section className="service-branding-section">
        <div className="service-branding-section-heading">
          <ImageOutlinedIcon fontSize="small" />
          <span>
            <strong>Set a logo</strong>
            <small>Optional image for this service</small>
          </span>
        </div>
        <div className="service-logo-editor">
          <div className="service-logo-preview">
            {logoUrl ? (
              <img src={logoUrl} alt="Service logo preview" />
            ) : (
              <ImageOutlinedIcon aria-label="No logo selected" />
            )}
          </div>
          <div className="service-logo-controls">
            <strong>{logoUrl ? "Logo selected" : "Choose a logo"}</strong>
            <span>PNG, JPEG or WebP, up to 2 MB.</span>
            <div className="button-row button-row-left">
              <label className="action-button compact service-logo-upload">
                {logoUrl ? "Replace" : "Choose logo"}
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/webp"
                  onChange={(event) => onLogoSelect(event.target.files?.[0])}
                />
              </label>
              {logoUrl && (
                <button
                  type="button"
                  className="action-button compact secondary"
                  onClick={onLogoRemove}
                >
                  Remove
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="service-branding-section">
        <div className="service-branding-section-heading">
          <PaletteOutlinedIcon fontSize="small" />
          <span>
            <strong>Set a colour</strong>
            <small>Used on service cards and icons</small>
          </span>
        </div>
        <label className="service-branding-colour-picker">
          <input
            type="color"
            value={colorHex}
            onChange={(event) => onColourChange(event.target.value)}
            aria-label="Choose service colour"
          />
          <span>
            <strong>Service colour</strong>
            <small>Tap the colour to change it</small>
          </span>
          <code>{colorHex}</code>
        </label>
      </section>
    </div>
  );
}
